<template>
  <div class="mainPage" @click="loginOut">退出登录</div>
</template>

<script>
export default {
  name: '',
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {
    // alert(1)
    // alert(document.cookie)
  },
  methods: {
    async loginOut() {
      let res = await this.$api.loginOutfromPC()
      console.log(res)
      if (res.data.status == 200) {
        alert('已退出登录了')

        this.$cookies.remove('token')
        this.$cookies.remove('login_type')
        this.$cookies.remove('roomNum')
        // this.$cookies.remove('token')
        // this.$cookies.set('token', '', '1d')
        // this.$cookies.set('roomNum', '', '1d')
        // this.$cookies.set('login_type', '', '1d')
        // this.$cookies.remove('login_type' ['', '/' ['', '']])
        // alert(document.cookie)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.mainPage {
  width: 100vw;
  height: 100vh;
  font-size: 0.12rem;
  display: flex;
  justify-content: center;
  align-items: center;
  }
</style>
